<template>
    <vForm :label-width="120" inline>
        <!-- 导入模板 -->
        <vFormItem :label="comptitle" prop="nodetype" :rules="required">
            <vSelect  v-model="nodetype" filterable >
                <vOption v-for="item in alltypes" :value="item.value" :key="item.value">{{item.label}}</vOption>
            </vSelect>
            <div class="color-error">{{erpskutitle}}</div>
        </vFormItem>
        <!-- <compUpload v-bind="getFileProps" @on-close="close" @on-success="success" :warningtitle="warningtitle"></compUpload> -->
        <compMutiUpload v-bind="getFileProps" @on-cancel="close" @on-success="success" :warningtitle="warningtitle"></compMutiUpload>
    </vForm>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props:['erpskutitle','warningtitle','actionurl','downrul','comptitle'],
    components: {
		// compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload")
	},
    data(){
        return {
            nodetype:0,
            alltypes: [
				{ value: '0', label: 'Shippinglabel' },
				{ value: '1', label: 'Packinglist' },
				{ value: '2', label: 'BOL' },
				{ value: '3', label: 'Other' },
				{ value: '4', label: 'CartonLabel' },
                { value: '5', label: 'PalletLabel' },
                { value: '6', label: 'itmelabel' },
			],
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'})
            }],

        }
    },
    computed: {
        getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_BOSS + this.actionurl,
				name: "file",
                multiple: true,
                accept: '.jpg, .jpeg, .pdf, .png',
                validFile: (file) => {
                    let fileName = file.name;
                    fileName = fileName.toLowerCase()
                    if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.pdf') || fileName.endsWith('.png')) return true;
                    this.$VMessage.error(this.$t('erp.distribution.upload_format_error', { defaultValue: '只能上传jpg/jpeg/pdf/png格式的文件' }));
                    return false;
                },
                beforeUpload: (dataList) => {
                    if (dataList.length > 80) {
                        this.$VMessage.error(this.$t('erp.b2corder.attach_not_more_than_80', { defaultValue: '附件个数不能大于80' }));
                        return false;
                    }
                    let flag = true;
                    dataList.map(item => {
                        console.log()
                        if (item.name.endsWith('.xls') || item.name.endsWith('.xlsx')) {
                            flag = false;
                        }
                    });
                    if (!flag) {
                        this.$VMessage.error(this.$t('erp.b2corder.attch_not_xls_format', { defaultValue: '不能上传xls或xlsx格式' }));
                        return false;
                    }
                    return true;
                },
				data: {
                    type: this.nodetype,
                },
                formatter (res) {
                    this.$VMessage.success(res.message);
                }
			}
		},
    },
    methods: {
        close(){
            this.$emit('on-close')
        },
        success(){
            // console.log(23423)
            this.close()
            this.$emit('on-update')
        }
    }
}
</script>
